import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComicsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const hotComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <div>
            <div className="flex items-baseline gap-3 mb-2">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                热门漫画
              </h2>
              <span className="text-lg font-heading text-primary-500">TOP 8</span>
            </div>
            <p className="text-sm text-foreground-500">千万读者口碑推荐，不容错过的韩漫佳作</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-200 hover:bg-background-300 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-foreground-600"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-200 hover:bg-background-300 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-foreground-600"></i>
            </button>
          </div>
        </div>

        {/* Cards */}
        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto scrollbar-hide pb-2 -mx-4 px-4 md:px-0"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotComics.map((comic, i) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex-shrink-0 w-[180px] md:w-[200px] group cursor-pointer"
            >
              {/* Cover */}
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                {/* Rank Badge */}
                <div className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-950/80 text-white text-sm font-bold">
                  {i + 1}
                </div>
              </div>
              {/* Info */}
              <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
              <div className="flex items-center gap-2 mt-1.5">
                <span className="flex items-center gap-0.5 text-xs text-accent-600">
                  <i className="ri-star-fill text-[10px]"></i>
                  {comic.rating}
                </span>
                <span className="text-xs text-foreground-400">
                  {(comic.views / 10000).toFixed(0)}万阅
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}